export enum PermissionType {
  // Dashboard Permissions
  PERM_MENU_DASHBOARD_VIEW = 'PERM_MENU_DASHBOARD_VIEW',
  PERM_MENU_DEVICE_CONTROL_VIEW = 'PERM_MENU_DEVICE_CONTROL_VIEW',

  // Monitoring Permissions
  PERM_MENU_MAP_VIEW = 'PERM_MENU_MAP_VIEW',
  PERM_MENU_MONITORING_VIEW = 'PERM_MENU_MONITORING_VIEW',
  PERM_MENU_STOP_VIEW = 'PERM_MENU_STOP_VIEW',
  PERM_MENU_STOP_DATASOURCE_VIEW = 'PERM_MENU_STOP_DATASOURCE_VIEW',
  PERM_MENU_TERMINAL_STATUSES_VIEW = 'PERM_MENU_TERMINAL_STATUSES_VIEW',
  PERM_MENU_PRODUCT_LOGS_VIEW = 'PERM_MENU_PRODUCT_LOGS_VIEW',
  PERM_MENU_PRODUCT_CONSOLE_VIEW = 'PERM_MENU_PRODUCT_CONSOLE_VIEW',
  PERM_MENU_TIMETABLE_SOURCE_DATA_VIEW = 'PERM_MENU_TIMETABLE_SOURCE_DATA_VIEW',

  // Real View Permissions
  PERM_MENU_REAL_VIEW = 'PERM_MENU_REAL_VIEW',
  PERM_MENU_PRODUCT_SN_VIEW = 'PERM_MENU_PRODUCT_SN_VIEW',

  // Template Permissions
  PERM_MENU_TEMPLATE_VIEW = 'PERM_MENU_TEMPLATE_VIEW',
  PERM_MENU_IMAGE_VIEW = 'PERM_MENU_IMAGE_VIEW',
  PERM_MENU_LAYOUT_VIEW = 'PERM_MENU_LAYOUT_VIEW',
  PERM_MENU_STATE_VIEW = 'PERM_MENU_STATE_VIEW',
  PERM_MENU_STOP_TEMPLATE_VIEW = 'PERM_MENU_STOP_TEMPLATE_VIEW',
  PERM_MENU_RASTER_FONT_VIEW = 'PERM_MENU_RASTER_FONT_VIEW',
  PERM_MENU_DISPLAY_VIEW = 'PERM_MENU_DISPLAY_VIEW',

  // System Permissions
  PERM_MENU_SYSTEM_VIEW = 'PERM_MENU_SYSTEM_VIEW',
  PERM_MENU_GROUP_VIEW = 'PERM_MENU_GROUP_VIEW',
  PERM_MENU_COMPANY_VIEW = 'PERM_MENU_COMPANY_VIEW',
  PERM_MENU_USER_VIEW = 'PERM_MENU_USER_VIEW',
  PERM_MENU_SERVER_VIEW = 'PERM_MENU_SERVER_VIEW',

  // Firmware Permissions
  PERM_MENU_FIRMWARE_VIEW = 'PERM_MENU_FIRMWARE_VIEW',

  // Announcement Permissions
  PERM_MENU_ANNOUNCEMENT_VIEW = 'PERM_MENU_ANNOUNCEMENT_VIEW',
  PERM_MENU_FLAG_VIEW = 'PERM_MENU_FLAG_VIEW',
  PERM_ANNOUNCEMENT_GROUP_WRITE = 'PERM_ANNOUNCEMENT_GROUP_WRITE',

  PERM_ANNOUNCEMENT_RICH_TEXT_WRITE = 'PERM_ANNOUNCEMENT_RICH_TEXT_WRITE',

  //About Permissions
  PERM_MENU_AUTH_SERVER_VIEW = 'PERM_MENU_AUTH_SERVER_VIEW',

  //STOP
  PERM_STOP_WRITE = 'PERM_STOP_WRITE',

  //FLAG
  PERM_FLAG_WRITE = 'PERM_FLAG_WRITE',

  //ProductSn
  PERM_PRODUCT_SN_WRITE = 'PERM_PRODUCT_SN_WRITE',
  PERM_PRODUCT_SN_SERVER_CHANGE_FULL = 'PERM_PRODUCT_SN_SERVER_CHANGE_FULL',
  PERM_PRODUCT_SN_SERVER_CHANGE_LIMITED = 'PERM_PRODUCT_SN_SERVER_CHANGE_LIMITED',

  //State
  PERM_STATE_WRITE = 'PERM_STATE_WRITE',

  //Layout
  PERM_LAYOUT_WRITE = 'PERM_LAYOUT_WRITE',

  //Dynamic TimeTable
  PERM_MENU_DYNAMIC_TIMETABLE_VIEW = 'PERM_MENU_DYNAMIC_TIMETABLE_VIEW',

  //Dictionary
  PERM_MENU_SCHEDULE_DICTIONARY_VIEW = 'PERM_MENU_SCHEDULE_DICTIONARY_VIEW',
  PERM_SCHEDULE_DICTIONARY_LIST = 'PERM_SCHEDULE_DICTIONARY_LIST',
  PERM_SCHEDULE_DICTIONARY_READ = 'PERM_SCHEDULE_DICTIONARY_READ',
  PERM_SCHEDULE_DICTIONARY_WRITE = 'PERM_SCHEDULE_DICTIONARY_WRITE',

  //HardwareVersion
  PERM_MENU_HARDWARE_VERSION_VIEW = 'PERM_MENU_HARDWARE_VERSION_VIEW',
  PERM_HARDWARE_VERSION_WRITE = 'PERM_HARDWARE_VERSION_WRITE',
}
